import Loader from "react-loader-spinner";
import { PencilSquare, PlusSquare, Trash, ExclamationTriangle, DashCircle } from 'react-bootstrap-icons';
import { Table, Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { getComplaintsTargetList, addEditComplaintsTarget, deleteComplaintsTarget } from "../store/api/ComplaintsAPI";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBorderAll, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalAddEditComplaintTarget = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const notForSelect = useRef(false);
    const [currentTarget, setCurrentTarget] = useState({ ID: 0 });
    const [error, setError] = useState(null);
    const [typeList, setTargetList] = useState(null);

    const close = () => {
        setPopData({
            show: false
        })
        setCurrentTarget({ ID: 0 });
    }
    const addOrUpdateTarget = () => {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }
            getComplaintsTargetList(setTargetList);
            setCurrentTarget({ ID: 0 });
        }
        if (
            !currentTarget.Target ||
            currentTarget.Target === '') {
            return;
        }
        currentTarget.IsActive = true;
        addEditComplaintsTarget(currentTarget, onSuccess);
    }
    const deleteTarget = (id) => {
        notForSelect.current = true;
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                getComplaintsTargetList(setTargetList);
            }
        }
        deleteComplaintsTarget(id, onDelete);
    }
    function cancelTarget() {
        setCurrentTarget({ ID: 0 });
    }
    function rowClick(row) {
        if (notForSelect.current) {
            notForSelect.current = false;
            return;
        }
        setCurrentTarget(row);
    }
    useEffect(() => {
        if (show)
            getComplaintsTargetList(setTargetList);
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faBorderAll} size="lg" style={{ marginLeft: "3px" }} /> مدیریت بخش های مورد شکایت </span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error && <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {error} <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} /></Alert>}
                <Table responsive className="fixedTable mt-2" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>ترتیب نمایش</th>
                            <th style={{ width: "60%" }}>شرح وضعیت</th>
                            <th style={{ width: "20%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(typeList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {Array.isArray(typeList?.Data ?? "") &&
                            typeList.Data.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => rowClick(item)}>
                                    <td style={{ width: "20%" }}>{item.ItemOrder}</td>
                                    <td style={{ width: "60%" }}>{item.Target}</td>
                                    <td style={{ width: "20%" }}>
                                        <Trash className="rowBtn" color="red" size={16} onClick={() => deleteTarget(item.ID)} />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                {currentTarget &&
                    <Row>
                        <Col md={3} style={{ padding: "3px", paddingRight: "10px" }}>
                            <input type="text" className="tableRowInput" value={currentTarget?.ItemOrder ?? ""} onChange={e => setCurrentTarget({ ...currentTarget, ItemOrder: e.target.value })} />
                        </Col>
                        <Col md={6} style={{ padding: "3px" }}>
                            <input type="text" className="tableRowInput" value={currentTarget?.Target ?? ""}
                                onChange={e => setCurrentTarget({ ...currentTarget, Target: e.target.value })} />
                        </Col>
                        <Col md={3} style={{ padding: "2px" }}>
                            <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdateTarget}>
                                {Number(currentTarget.ID) > 0 && <PencilSquare size={18} />}
                                {Number(currentTarget.ID) === 0 && <PlusSquare size={18} />}
                            </Button>
                            <Button className="group-Btn-smalll" variant="danger"><DashCircle size={18} onClick={cancelTarget} /></Button>
                        </Col>
                    </Row>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddEditComplaintTarget;